module.exports = __webpack_public_path__ + "img/aiyuigon-banner-sp.88c37d0b.svg";